import React from "react";
import styled from "styled-components";
import ValidatedInput from "integrations/aws/common/ValidatedInput";
import MaskedInput from "integrations/aws/common/MaskedInput";
const StyledMaskedInput = styled(MaskedInput)`
  margin-bottom: 0;
`;
const KeySecret = ({ onChange, awsKey = void 0, awsSecret = void 0, required = true }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
  ValidatedInput,
  {
    id: "awsAccessKey",
    type: "text",
    label: "AWS Access Key",
    placeholder: "AK****************",
    onChange,
    fieldData: awsKey,
    autoComplete: "off",
    maxLength: 512,
    help: required ? 'Your AWS Key should be a 20-character long, alphanumeric string that starts with the letters "AK".' : 'Your AWS Key should be a 20-character long, alphanumeric string that starts with the letters "AK". (Optional - will use legacy AWS plugin configuration if not provided)',
    required
  }
), /* @__PURE__ */ React.createElement(
  StyledMaskedInput,
  {
    id: "awsSecretKey",
    label: "AWS Secret Key",
    placeholder: "***********",
    onChange,
    fieldData: awsSecret,
    autoComplete: "off",
    maxLength: 512,
    help: required ? "Your AWS Secret is usually a 40-character long, base-64 encoded string." : "Your AWS Secret is usually a 40-character long, base-64 encoded string. (Optional - will use legacy AWS plugin configuration if not provided)",
    required
  }
));
export default KeySecret;
